import React from 'react';
import SEO from '../components/SEO';

const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-sage-50 via-taupe-50 to-sage-100 flex items-center justify-center p-6">
      <SEO 
        title="Coming Soon | Mind Games Family Counseling & Therapy Inc."
        description="Mind Games Family Counseling & Therapy Inc. is launching soon. Mental clarity. Emotional strength. Confident living."
      />
      
      <div className="text-center max-w-xl mx-auto">
        {/* Logo */}
        <div className="mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_wellness-confidence/artifacts/8uneor3p_5B1FDA40-334A-4855-84E5-C226E88B7797.png" 
            alt="Mind Games Family Counseling & Therapy Inc." 
            className="h-32 sm:h-40 mx-auto"
          />
        </div>

        {/* Coming Soon Badge */}
        <div className="inline-block mb-6">
          <span className="bg-sage-600 text-white text-sm font-medium px-4 py-2 rounded-full">
            Launching Soon
          </span>
        </div>

        {/* Tagline */}
        <h1 className="text-3xl sm:text-4xl font-serif text-gray-800 mb-4">
          Mental clarity. <span className="text-sage-600 italic">Emotional strength.</span> Confident living.
        </h1>

        {/* Footer */}
        <p className="mt-12 text-sm text-gray-500">
          © {new Date().getFullYear()} Mind Games Family Counseling & Therapy Inc.
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
